import { __decorate } from 'tslib';
import { ɵɵdefineInjectable, Injectable, Component, NgModule } from '@angular/core';
import { createFeatureSelector, createSelector } from '@ngrx/store';

let OlPlatformService = class OlPlatformService {
    constructor() { }
};
OlPlatformService.ɵprov = ɵɵdefineInjectable({ factory: function OlPlatformService_Factory() { return new OlPlatformService(); }, token: OlPlatformService, providedIn: "root" });
OlPlatformService = __decorate([
    Injectable({
        providedIn: 'root',
    })
], OlPlatformService);

let OlPlatformComponent = class OlPlatformComponent {
    constructor() { }
    ngOnInit() { }
};
OlPlatformComponent = __decorate([
    Component({
        selector: 'lib-ol-platform',
        template: `
    <p>
      ol-platform works!
    </p>
  `
    })
], OlPlatformComponent);

let OlPlatformModule = class OlPlatformModule {
};
OlPlatformModule = __decorate([
    NgModule({
        declarations: [OlPlatformComponent],
        imports: [],
        exports: [OlPlatformComponent],
    })
], OlPlatformModule);

const getApplicationContext = createFeatureSelector('context');
const ɵ0 = (state) => state.user;
const getPerson = createSelector(getApplicationContext, ɵ0);

const getEnvironmentContextState = createFeatureSelector('environmentContext');
const ɵ0$1 = (state, props) => {
    const stateMap = Object.assign({}, state);
    return stateMap[props.key];
};
const getEnvironmentContextData = createSelector(getEnvironmentContextState, ɵ0$1);

const getSession = createFeatureSelector('session');
const ɵ0$2 = (state) => state.token;
const getUserToken = createSelector(getSession, ɵ0$2);

const getCourseExperienceState = createFeatureSelector('courseExperience');
const ɵ0$3 = (state) => {
    return state;
};
const getCourseExperienceData = createSelector(getCourseExperienceState, ɵ0$3);
const ɵ1 = (state) => state.productXID;
const getCourseExperienceProductXid = createSelector(getCourseExperienceState, ɵ1);
const ɵ2 = (state) => state.licenseMessage;
const getLicenseMessage = createSelector(getCourseExperienceState, ɵ2);

var CourseExperienceActions;
(function (CourseExperienceActions) {
    CourseExperienceActions["LoadCourseExperience"] = "[ Context CourseExperience ] Load Course Experience";
})(CourseExperienceActions || (CourseExperienceActions = {}));
class CourseExperienceAction {
    constructor(payload) {
        this.payload = payload;
        this.type = CourseExperienceActions.LoadCourseExperience;
    }
}

// TODO: Deprecated
var StartEmulationActions;
(function (StartEmulationActions) {
    StartEmulationActions["LoadStartEmulation"] = "[ Context StartEmulation ] Load Start Emulation";
    StartEmulationActions["LoadStartEmulationSuccess"] = "[ Context StartEmulation ] Start Emulation Success";
    StartEmulationActions["LoadStartEmulationFail"] = "[ Context StartEmulation ] Start Emulation Fail";
})(StartEmulationActions || (StartEmulationActions = {}));
var EmulationActions;
(function (EmulationActions) {
    EmulationActions["LoadStartEmulation"] = "[ Context StartEmulation ] Load Start Emulation";
    EmulationActions["LoadStartEmulationSuccess"] = "[ Context StartEmulation ] Start Emulation Success";
    EmulationActions["LoadStartEmulationFail"] = "[ Context StartEmulation ] Start Emulation Fail";
    EmulationActions["EndEmulation"] = "[ Context EndEmulation ] End Emulation";
    EmulationActions["EndEmulationSuccess"] = "[ Context EndEmulation ] End Emulation Success";
    EmulationActions["EndEmulationFail"] = "[ Context EndEmulation ] End Emulation Fail";
})(EmulationActions || (EmulationActions = {}));
class StartEmulationAction {
    constructor(payload) {
        this.payload = payload;
        this.type = EmulationActions.LoadStartEmulation;
    }
}
class StartEmulationSuccess {
    constructor() {
        this.type = EmulationActions.LoadStartEmulationSuccess;
    }
}
class StartEmulationFail {
    constructor() {
        this.type = EmulationActions.LoadStartEmulationFail;
    }
}
class EndEmulationAction {
    constructor() {
        this.type = EmulationActions.EndEmulation;
    }
}
class EndEmulationSuccessAction {
    constructor() {
        this.type = EmulationActions.EndEmulationSuccess;
    }
}
class EndEmulationFailAction {
    constructor() {
        this.type = EmulationActions.EndEmulationFail;
    }
}

var SectionActions;
(function (SectionActions) {
    SectionActions["UpdateSectionConfig"] = "[ Sections Config ] Update";
})(SectionActions || (SectionActions = {}));
class UpdateSectionConfigAction {
    constructor(payload) {
        this.payload = payload;
        this.type = SectionActions.UpdateSectionConfig;
    }
}

/*
 * Public API Surface of ol-platform
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CourseExperienceAction, CourseExperienceActions, EmulationActions, EndEmulationAction, EndEmulationFailAction, EndEmulationSuccessAction, OlPlatformComponent, OlPlatformModule, OlPlatformService, SectionActions, StartEmulationAction, StartEmulationActions, StartEmulationFail, StartEmulationSuccess, UpdateSectionConfigAction, getApplicationContext, getCourseExperienceData, getCourseExperienceProductXid, getCourseExperienceState, getEnvironmentContextData, getEnvironmentContextState, getLicenseMessage, getPerson, getUserToken, ɵ0, ɵ1, ɵ2 };
